module.exports = __webpack_public_path__ + "static/media/camisa.1127642c.png";